import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { driverChangesApi } from "@/api/driverChanges.api";
import { queryKeys } from "@/utils/queryKeys";
import type { DriverChangeStatus } from "@/types/domain";

export function useDriverChanges(status: DriverChangeStatus) {
  return useQuery({
    queryKey: queryKeys.driverChanges.list(status),
    queryFn: () => driverChangesApi.list({ status, limit: 50 }),
    refetchInterval: 30_000,
  });
}

function useInvalidatingMutation<V>(fn: (v: V) => Promise<unknown>) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fn,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["driverChanges"] }),
  });
}

export const useApproveDriverChange = () => useInvalidatingMutation((id: string) => driverChangesApi.approve(id));
export const useRejectDriverChange = () =>
  useInvalidatingMutation((v: { id: string; reason: string }) => driverChangesApi.reject(v.id, v.reason));
